import React, { Component, Fragment } from 'react'
import { Layout } from 'antd'
import { Header } from '../Components'

import './layout.css'

const { Content } = Layout

class DashboardLayout extends Component {
  render() {
    return (
      <Fragment>
        <Header />
        <Content className='site-layout-background content'>
          <div >
            {React.cloneElement(this.props.children, { ...this.props })} </div>
        </Content>
      </Fragment>
    )
  }
}

export default DashboardLayout
